import Vue from 'vue';
import VueRouter from 'vue-router';

import Login from './components/auth/Login.vue';
import Auth from './components/auth/Auth.vue';
import Callback from './components/auth/Callback.vue';
import Contact from './components/auth/Contact.vue';
import Forbidden from './components/auth/Forbidden.vue';
import PageNotFound from './components/auth/PageNotFound.vue';
import Profil from './components/Profil.vue';
import authService from './services/auth.service';
import MagicPassword from './components/auth/MagicPassword.vue';

Vue.use(VueRouter);

export const router = new VueRouter({
    mode: 'history',
    //base: process.env.BASE_URL,
    routes : [
        { name:'Home', path: process.env.BASE_URL, redirect: {name: 'Login'}},
        { name:'Login', path: process.env.BASE_URL + 'login', component: Login},
        { name:'Callback', path: process.env.BASE_URL + 'callback', component: Callback,
            props: (route) => ({ code: route.query.code, state: route.query.state })},
        { name: 'Auth', path: process.env.BASE_URL + 'auth', component: Auth, props: true, meta: {idRequired: true}},
        { name:'Contact', path: process.env.BASE_URL + 'contact', component:Contact, props: true},
        { name:'403', path: process.env.BASE_URL + '403',  component: Forbidden},
        { name: 'MagicPassword', path: process.env.BASE_URL + 'magic', component: MagicPassword, props: true},
        { name:'Profil', path: process.env.BASE_URL + 'profil', component: Profil,
            meta: {idRequired: true, authRequired: true}},
        {
            path: "/:pathMatch(.*)*",
            component: PageNotFound,
        },
    ]
});
  
router.beforeEach((to, from, next) => {
    //const idRequiredPages = ['/auth', '/profil'];
    //const authRequiredPages = ['/profil'];
    const idRequired = to.matched.some(record => record.meta.idRequired);
    const authRequired = to.matched.some(record => record.meta.authRequired);

    const isIdentified = authService.isIdentified();
    const isAuthenticated = authService.isAuthenticated();

    if (idRequired && !isIdentified) {
      next({name: 'Login'});
    } else if (authRequired && !isAuthenticated) {
      next({name: 'Auth'});
    } else {
      next();
    }

  });